const url = {
  getUser: "/api/user/get",
  updateUser: "/api/user/update",
  deleteUser: "/api/user/delete",
  login: "/api/auth/login",
  logout: "/api/auth/logout",
  register: "/api/auth/register",
  resetPassword: "/api/auth/reset-password",
  changePassword: "/api/auth/change-password",
  verifyEmail: "/api/auth/verify-email",
  sendVerificationEmail: "/api/auth/send-verification-email",
  getScript: "/api/script/post",
};

export default url;
